
        <app-authorizenet-payment [config]="authorizenetConfig" (authorizeNetResponseHandler)="responseHandler($event)" ButtonText="Pay Now">

        </app-authorizenet-payment>

<ngx-spinner name="payment" type="ball-scale-multiple"><p style="color: white" > Your Order’s being Processed. If you’re not automatically redirected,refresh this page. </p></ngx-spinner>